export const queryKeyFactory = {
	root: ['auth'] as const,
	userAccesses: () => [...queryKeyFactory.root, 'user-accesses'] as const,
	accesses: () => [...queryKeyFactory.root, 'accesses'] as const,
	checkAuthentication: () => [...queryKeyFactory.root, 'check-authentication'] as const,
	currentUser: () => [...queryKeyFactory.root, 'current-user'] as const,
	validateUserPasswordToken: (token: string | null) =>
		[...queryKeyFactory.root, 'validate-user-password-token', token] as const,
};

export const authKeys = queryKeyFactory;
